export enum AiChatErrorCode {
	BUDGET_EXCEEDED = 'llm_budget_exceeded',
	RATE_LIMITED = 'llm_rate_limited',
	REQUEST_RATE_LIMITED = 'rate_limit_exceeded',
	VALIDATION_ERROR = 'validation_error',
	GATEWAY_TIMEOUT = 'gateway_timeout',
	FORBIDDEN = 'forbidden',
	SERVICE_UNAVAILABLE = 'service_unavailable',
	UNAUTHORIZED = 'unauthorized',
	INTERNAL_SERVER_ERROR = 'internal_server_error',
}
